<template>
  <div class="alertModal" :style="{ display: (openDialog ? 'flex' : 'none') }">
    <div class="alertDialogBox">
      <div>
        <span>外部サイトへと移動します。</span><br>
        <div v-if="!isSpecial">
        リンク先のウェブサイトは東京カメラ部が運営するサイトではありません。<br>
        万が一トラブルが発生した場合、東京カメラ部は一切関与いたしません。<br>
        また、問い合わせにも対応いたしかねますのでご了承ください。<br>
        </div>
      </div>
      <div class= "alertButtonArea">
        <div class= "alertButtonOk" @click="goToLink">OK</div>
        <div class= "alertButtonCansel" @click="close">Cancel</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: [
    'isOpen',
    'link',
    'isSpecial'
  ],
  data () {
    return {
      dialogOpen: false
    }
  },
  computed: {
    openDialog: {
      get () {
        return this.isOpen
      },
      set (value) {
        this.$emit('update:isOpen', value)
      }
    }
  },
  methods: {
    close () {
      this.$ga.event('ExternalSiteAlertDialog', 'cancel', `${this.link}`, null)
      this.openDialog = false
    },
    goToLink() {
      this.$ga.event('ExternalSiteAlertDialog', 'ok', `${this.link}`, null)
      window.open(this.link, '_blank')
      this.openDialog = false
    }
  },
  watch: {
    isOpen: function (val) {
      if (val) {
        this.$ga.event('ExternalSiteAlertDialog', 'open', `${this.link}`, null)
      }
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>

<style scoped>
.alertModal {
  font-family: "Noto Sans JP";
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  overflow-y: auto;
  display: none;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
}
.alertDialogBox {
  width: 100%;
  margin: 16px;
  max-width: 520px;
  min-height: 200px;
  padding: 20px 16px 10px;
  font-size: 13px;
  background-color: white;
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}
.alertDialogBox span{
  font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
    display: inline-block;
}

.alertButtonArea{
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top:10px;
}

.alertButtonOk{
  border: solid 1px #999999;
  margin: 8px;
  padding: 8px 20px;
    font-weight: 700;
  cursor: pointer;
  background-color: #000;
  color: white;
}

.alertButtonCansel{
  border: solid 1px #999999;
  margin: 8px;
  padding: 8px 10px;
  cursor: pointer;
    font-weight: 700;
  background-color: grey;
  color: white;
}
.alertButtonOk:hover,
.alertButtonCansel:hover {
	opacity: 0.5;
	transition: opacity .4s ease-in-out;
	-moz-transition: opacity .4s ease-in-out;
	-webkit-transition: opacity .4s ease-in-out;
}


</style>
